var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageCard',{staticStyle:{"padding-top":"15px"},attrs:{"sm":"","title":"Calendar"}},[(!_vm.dashboardStats)?_c('Spinner'):_c('div',[_c('v-calendar',{staticStyle:{"width":"100%"},attrs:{"attributes":_vm.calendarAttributes},on:{"update:from-page":_vm.handleFromPageUpdate}}),_c('ColorLabelView',{attrs:{"labels":[
                { color: '#EF2B1F', title: 'Holidays' },
                { color: '#1E88E5', title: 'Leaves' },
                { color: '#7C2273', title: 'Birthdays' },
            ]}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }